/**
 * 复制文本到剪贴板（兼容低版本 Android / 华为）
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // 优先尝试 Clipboard API
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // Clipboard API 失败（Android WebView/非 HTTPS/华为），继续 fallback
  }
  // fallback: execCommand
  try {
    const el = document.createElement('textarea')
    el.value = text
    el.setAttribute('readonly', '')
    el.style.cssText = 'position:fixed;left:-9999px;opacity:0'
    document.body.appendChild(el)
    el.select()
    el.setSelectionRange(0, text.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(el)
    return ok
  } catch {
    return false
  }
}
